import { siteConfig } from '@/configs/siteConfig';

import { waveLineMv } from '@/pages/home/waveLineMv';

const props = {} as const;

const state = {
  resize: {
    timerId: undefined as ReturnType<typeof setTimeout> | undefined,
    handler: undefined as ((e: UIEvent) => void) | undefined,
  },

  scroll: {
    timerId: undefined as ReturnType<typeof setTimeout> | undefined,
    handler: undefined as ((e: Event) => void) | undefined,
  },

  orientationchange: {
    handler: undefined as ((e: Event) => void) | undefined,
  },

  beforeunload: {
    handler: undefined as ((e: BeforeUnloadEvent) => void) | undefined,
  },
};

export const homeController = {
  init() {
    // ### RUN ###
    waveLineMv.init();
    // ### RUN END ###
    //
    // ### EVENT ###
    // this.load();
    // this.resize();
    // this.scroll();
    // this.orientationchange();
    // this.beforeunload();
    // ### EVENT END ###
  },

  destroy() {
    waveLineMv.reset();

    this.removeResize();
    this.removeScroll();
    this.removeOrientationchange();
    this.removeBeforeunload();
  },

  load() {
    window.addEventListener('load', () => {
      // ### RUN ###
      // ### RUN END ###
    });
  },

  resize() {
    if (state.resize.handler) return;

    state.resize.handler = (e: UIEvent) => {
      clearTimeout(state.resize.timerId);
      state.resize.timerId = setTimeout(() => {
        // ### RUN ###
        // ### RUN END ###
      }, siteConfig.delay.resize);
    };

    window.addEventListener('resize', state.resize.handler);
  },
  removeResize() {
    if (!state.resize.handler) return;

    window.removeEventListener('resize', state.resize.handler);
    state.resize.handler = undefined;

    if (state.resize.timerId) {
      clearTimeout(state.resize.timerId);
      state.resize.timerId = undefined;
    }
  },

  scroll() {
    if (state.scroll.handler) return;

    state.scroll.handler = (e: Event) => {
      clearTimeout(state.scroll.timerId);
      state.scroll.timerId = setTimeout(() => {
        // ### RUN ###
        // ### RUN END ###
      }, siteConfig.delay.scroll);
    };

    window.addEventListener('scroll', state.scroll.handler);
  },
  removeScroll() {
    if (!state.scroll.handler) return;

    window.removeEventListener('scroll', state.scroll.handler);
    state.scroll.handler = undefined;

    if (state.scroll.timerId) {
      clearTimeout(state.scroll.timerId);
      state.scroll.timerId = undefined;
    }
  },

  orientationchange() {
    if (state.orientationchange.handler) return;

    state.orientationchange.handler = (e: Event) => {
      // ### RUN ###
      // ### RUN END ###
    };

    window.addEventListener('orientationchange', state.orientationchange.handler);
  },
  removeOrientationchange() {
    if (!state.orientationchange.handler) return;

    window.removeEventListener('orientationchange', state.orientationchange.handler);
    state.orientationchange.handler = undefined;
  },

  beforeunload() {
    if (state.beforeunload.handler) return;

    state.beforeunload.handler = (e: BeforeUnloadEvent) => {
      // ### RUN ###
      // ### RUN END ###
    };

    window.addEventListener('beforeunload', state.beforeunload.handler);
  },
  removeBeforeunload() {
    if (!state.beforeunload.handler) return;

    window.removeEventListener('beforeunload', state.beforeunload.handler);
    state.beforeunload.handler = undefined;
  },
};
